export default "/images/vendor/flag-icon-css/flags/1x1/ee.svg?fe4d22ce233d1de3dbc11d40053a133c";